var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Transaction',{ref:"transactionEmbedFieldRef",attrs:{"menu":{
      transactionName: _vm.value ? _vm.value.transactionName : null,
      selected: true,
      permission: _vm.permission,
    },"environment":_vm.environment,"inputData":_vm.buildInputData(_vm.inputFields),"session":_vm.session,"generalExApplicationEx":_vm.generalExApplicationEx,"customLanguage":_vm.customLanguage,"embeddedField":true},on:{"update-notification":_vm.updateNotification,"load-transaction":_vm.loadTransaction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }